import { ChoicesWithTextKey } from "./reject_common";

export type RejectReason =
  | "photo1"
  | "photo2"
  | "date"
  | "date2"
  | "blood_station"
  | "wrong_fio"
  | "need_screenshot";

export type RejectReasonType = {
  [s in RejectReason]: ChoicesWithTextKey;
};

export const REJECT_REASONS: RejectReasonType = {
  photo1: {
    text: "Фотография имеет неразборчивое отображение",
    key: "image_id",
  },
  photo2: { text: "Необходима справка по формам 402/у, 405-05/у или 448-05/у", key: "image_id" },
  date: { text: "Расставьте верно даты донаций в профиле", key: "donate_at" },
  date2: { text: "Создайте нужное число донаций с датами согласно приложенной справке", key: "donate_at2"},
  blood_station: { text: "Центр крови указан неверно", key: "errorStation" },
  wrong_fio: {
    text: "ФИО на справке и в профиле не совпадает",
    key: "wrong_fio",
  },
  need_screenshot: {text: "Сделайте скриншот каждой донации в Госуслугах, где видны ФИО, дата, тип и номер донации", key: "image_id"}
};
